// The state of outfit sharing in the web builder.
export enum OutfitSharingStateEnum {
  // An outfit share is not being prepared by native. The outfit share button spinner should not show.
  NOT_LOADING = 'NOT_LOADING',
  // An outfit share is being prepared by native. The outfit share button spinner should show.
  LOADING = 'LOADING',
  // The outfit that the user attempted to share was deprecated and cannot be shared. The the deprecated outfit dialog should show and outfit share button spinner should not show.
  OUTFIT_DEPRECATED = 'OUTFIT_DEPRECATED',
}
